/** Customers, addresses and dues (docs/specs/customers.md). */
export const customers = {
    title: "Customers",
    description: "Everyone who buys from you, online or in the shop, found by phone.",
    new: "New customer",
    search: "Search name or phone",
    tag: "Tag",
    group: "Group",
    dueOnly: "Only customers with dues",
    columns: { name: "Name", phone: "Phone", tags: "Tags", balance: "Due", limit: "Credit limit" },
    empty: "No customers yet.",
    back: "All customers",
    due: "Due",
    advance: "Paid in advance",
    creditLimit: "Credit limit",
    noCredit: "No credit sales (limit 0)",
    conflict: "Someone else changed this customer. The latest version is shown; try again.",
    form: {
        titleNew: "New customer",
        titleEdit: "Edit customer",
        name: "Name",
        phone: "Mobile number",
        altPhone: "Second mobile number",
        email: "Email",
        tags: "Tags (comma-separated)",
        groups: "Groups (comma-separated)",
        note: "Note",
        creditLimit: "Credit limit",
        creditLimitHint: "The most this customer may owe from credit sales. 0 = no credit.",
        openingDue: "Already owes (opening due)",
        openingDueHint: "What this customer owed before using the system. Entered once.",
        save: "Save customer",
        phoneTaken: "Another customer has this number. Search for them instead.",
    },
    created: "Customer added.",
    saved: "Customer saved.",
    edit: "Edit",
    addresses: {
        title: "Addresses",
        add: "Add address",
        edit: "Edit",
        remove: "Remove",
        removed: "Address removed.",
        saved: "Address saved.",
        empty: "No addresses yet.",
        label: "Label (Home, Office…)",
        recipient: "Recipient (if someone else)",
        phone: "Phone at this address",
        division: "Division",
        district: "District",
        upazila: "Upazila / Thana",
        line: "House, road, area",
        isDefault: "Default address",
        default: "Default",
        save: "Save address",
        cancel: "Cancel",
    },
    ledger: {
        title: "Dues",
        empty: "No dues entries yet.",
        columns: { date: "Date", entry: "Entry", amount: "Amount", balance: "Balance after" },
        types: {
            opening: "Opening due",
            credit_sale: "Credit sale",
            sale_return: "Return",
            payment: "Payment",
            adjustment: "Adjustment",
            reversal: "Reversal",
            merge_in: "Moved in (merge)",
            merge_out: "Moved out (merge)",
        },
        reversedLabel: "Reversed",
        payment: "Take payment",
        amount: "Amount",
        method: "Method",
        reference: "Reference (TrxID)",
        note: "Note",
        savePayment: "Save payment",
        paid: "Payment saved.",
        adjust: "Adjust dues",
        adjustAmount: "Change (+ owes more, − owes less)",
        adjustNote: "Why?",
        saveAdjustment: "Save adjustment",
        adjusted: "Dues adjusted.",
        reverse: "Reverse",
        reverseNote: "Why reverse?",
        reversed: "Entry reversed.",
        methods: {
            cash: "Cash",
            card: "Card",
            bkash: "bKash",
            nagad: "Nagad",
            rocket: "Rocket",
            bank_transfer: "Bank transfer",
            other: "Other",
        },
    },
    statement: {
        title: "Statement",
        from: "From",
        to: "To",
        make: "Make PDF",
    },
    reminder: {
        send: "Send SMS reminder",
        sent: "Reminder queued.",
        sendAll: "Remind everyone with dues",
        sentAll: "Reminders are being sent to customers with dues.",
    },
    merge: {
        title: "Merge into another customer",
        description: "Use this when the same person was added twice. This customer's addresses, dues and orders move to the one you pick; this record goes away.",
        search: "Find the customer to keep",
        confirm: "Merge into {{name}}",
        done: "Customers merged.",
        open: "Merge…",
    },
};
//# sourceMappingURL=customers.js.map